import React, { Children, useEffect, useState } from "react";
import { Box, Button, Text, Title } from "@mantine/core";
import {
  MantineProvider,
  Container,
  Paper,
  Radio,
  useMantineTheme,
} from "@mantine/core";

interface Props {
  BrandName: string;
  children: React.ReactNode;
  disableButton?: boolean;
  onclick: any;
  isSelected: Boolean;
}

const EhrBrandCard: React.FC<Props> = ({
  BrandName,
  children,
  disableButton,
  onclick,
  isSelected,
}) => {
  const theme = useMantineTheme();
  const [isChecked, setIsChecked] = useState(false);

 
  return (
    <Box
      onClick={() => onclick(BrandName)}
      sx={{
        width: "230px",
        height: "136px",
        borderRadius: "8px",
        border: "1px solid #c9cdd3",
        padding: "16px",
        backgroundColor: disableButton ? "#D9D9D99E" : "transparent",
        opacity:disableButton?0.5:3
        
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <Text
              sx={{
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "30px",
              }}
            >
              {BrandName}
            </Text>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Radio
              checked={isSelected == true ? true : false}
              disabled={disableButton}
            />{" "}
          </Box>
        </Box>

        <Box
          id="Imax"
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "39px",
            padding: "16px",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default EhrBrandCard;
